import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ProjectResolved } from '../models/Project';
import { Observable, of } from 'rxjs';
import { ProjectService } from './project.service';
import { map, catchError, switchMap } from 'rxjs/operators';
import { TenantService } from './tenant.service';
import { NotificationService } from './notification.service';
import { TranslateService } from './translate.service';

@Injectable({ providedIn: 'root' })
export class ProjectResolverService implements Resolve<ProjectResolved> {

  constructor(public projectService: ProjectService,
    public translate:TranslateService,
    private tenantService: TenantService,
    private notificationService: NotificationService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): ProjectResolved | Observable<ProjectResolved> | Promise<ProjectResolved>{

    //console.log(route.paramMap)
    const id = route.paramMap.get('id') as string;
    const tenantdb:string = this.tenantService.currentTenantName;

    // if(isNaN(+id)){
    if (id === '') {
      const message = `No Project id was provided: ${id}`;
      console.log(message);
      // return of({ projectDto: null, error: message });
      return of(new ProjectResolved)
    }

    // this.tenantService.createApplicationToken(tenantdb, id).subscribe({
    //   next: (appToken) => {
    //     this.tenantService.storeToken(appToken);
    //     console.log("-----> project-resolver.service getTenantProject")
    //     return this.tenantService.getTenantProject(tenantdb, id)
    //     .pipe(
    //       map(projectDto => ({ projectDto: projectDto })),
    //       catchError(error => {
    //         const message = `Retrieval error: ${error}`;
    //         console.error(message);
    //         //return of({ projectDto: null, error: message });
    //         return of(new ProjectResolved)
    //       }));
    //   },
    //   error: () => {
    //     this.notificationService.error(`${this.translate.data["ERROR"]}`, "createApplicationToken error")
    //     return of(new ProjectResolved)
    //   }
    // })

      if (tenantdb === 'admin' ||  tenantdb === String(null) || tenantdb === '') {
        return this.projectService.getProject(id)
          .pipe(
            map(projectDto => ({ projectDto: projectDto })),
            catchError(error => {
              const message = `Retrieval error: ${error}`;
              console.error(message);
              //return of({ projectDto: null, error: message });
              return of(new ProjectResolved)
            }));
      }
      else {
        return this.tenantService.getTenantProject(tenantdb, id)
          .pipe(
            map(projectDto => ({ projectDto: projectDto })),
            catchError(error => {
              const message = `Retrieval error: ${error}`;
              console.error(message);
              //return of({ projectDto: null, error: message });
              return of(new ProjectResolved)
            }));
      }
  }
}

